import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { EditOutlined } from "@ant-design/icons";

import StatusCard from "components/cards/StatusCard";
import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import Loading from "components/App/Loading";
import ManagePostButton from "components/buttons/ManagePostButton";
import Table from "components/Tables/Table";
import TableImage from "components/Tables/TableImage";
import { Cascader } from "components/inputs/Select";
import { getState } from "state/selector";
import { GlassCard, CardsContainer } from "components/App/styled";
import { updateUser } from "state/actions";

function Index(props) {
  console.log("store redux", props.store);
  const [managePostModal, setManagePostModal] = useState(false);
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);
  const [posts, setPosts] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);

  console.log("dashboard/index data", data);
  useEffect(() => {
    Fetch.get("/posts", (res) => {
      if (res) {
        setPosts(res.posts);
        setData(res.posts);
        setReload(false);
      }
    });
    setReload(false);
  }, [reload]);

  function handleUpdate(index) {
    setUpdateModal(posts[index]);
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <GlassCard style={{ padding: "16px 4px" }}>
        <ManagePostButton
          reload={setReload}
          data={data}
          visible={managePostModal}
          setVisible={setManagePostModal}
        />
        <ManagePostButton
          reload={setReload}
          data={data}
          oldData={updateModal}
          visible={updateModal ? true : false}
          setVisible={setUpdateModal}
          buttonStyle={{ display: "none" }}
        />
        <Cascader
          allowClear={false}
          placeholder="دسته بندی"
          options={[
            { value: "همه", label: "همه" },
            { value: "article", label: "مقاله" },
            { value: "vet", label: "دامپزشکی" },
          ]}
          optionFilterProp="children"
          onChange={(value) => {
            if (value[0] === "همه") {
              setPosts(data);
            } else {
              setPosts(data.filter((item) => item.category === value[0]));
            }
          }}
          style={{ marginTop: 8, borderRadius: "24px !important" }}
        />
        {/* <Filters data={data} posts={posts} setPosts={setPosts} /> */}
      </GlassCard>

      <TableContainer>
        <Table
          loading={reload}
          columns={tableHeaders}
          dataSource={posts?.map((item, index) => ({
            ...item,
            image: <TableImage data={JSON.parse(item.images)} />,
            category: item.category === "article" ? "مقاله" : "دامپزشکی",
            updated_at: new Date(item.updated_at).toLocaleDateString("fa-IR"),
            actions: (
              <div className="row">
                <Button onClick={() => handleUpdate(index)}>
                  <EditOutlined />
                </Button>
                <DeleteButton
                  id={item.id}
                  reload={setReload}
                  title="پست"
                  link="posts"
                />
              </div>
            ),
            key: index + 1,
          }))}
        />
      </TableContainer>
    </>
  );
}
const mapStateToProps = (state) => {
  const store = getState(state);
  return { store };
};
export default connect(mapStateToProps, { updateUser })(Index);

const TableContainer = styled.div`
  margin-top: 48px;
  margin-bottom: 48px;
`;

const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  {
    title: "تصویر",
    dataIndex: "image",
    key: "image",
    align: "center",

    width: "80px",
  },
  {
    title: "عنوان",
    dataIndex: "title",
    key: "title",
    align: "center",

    width: "100px",
    ellipsis: true,
  },
  {
    title: "دسته بندی",
    dataIndex: "category",
    key: "category",
    align: "center",

    width: "80px",
  },
  {
    title: "آخرین تغییر",
    dataIndex: "updated_at",
    key: "updated_at",
    align: "center",
    ellipsis: true,

    width: "80px",
  },
  {
    title: "اعمال",
    dataIndex: "actions",
    key: "actions",
    align: "center",
    width: "80px",
  },
];
